import { Head, Link } from '@inertiajs/react';
import { ArrowLeft } from 'lucide-react';
import { useMessages } from '@/lib/use-messages';
import type { TourSponsorMedia } from '@/types';
import LinkedInPostCard from './components/linkedin-post-card';
import { linkedinPosts } from './linkedin-posts';

// `/tour/sponsor/media` (app/[locale]/tour/sponsor/media/page.tsx) — every Hack 25
// LinkedIn post as a grid, behind the carousel the deck shows.
export default function Media({ locale }: TourSponsorMedia) {
  const t = useMessages('tourSponsor', locale);

  return (
    <div className="theme-tour-sponsor min-h-screen bg-background font-sans text-foreground">
      <Head title="Platanus Hack 26 Tour | Sponsors">
        <meta
          name="description"
          content="Platanus Hack 26: Latam Tour. La mejor hackatón de Latam visita Argentina, México, Colombia, Venezuela y Chile."
        />
      </Head>
      <div className="min-h-screen bg-background px-4 py-10 md:px-8">
        <div className="mx-auto max-w-7xl">
          <Link
            href={`/${locale}/tour/sponsor`}
            className="mb-8 inline-flex items-center gap-2 text-muted-foreground text-sm transition-colors hover:text-foreground"
          >
            <ArrowLeft className="h-4 w-4" />
            Volver
          </Link>

          <h1 className="mb-10 font-bold text-3xl md:text-4xl">
            {t('linkedin.title')}
          </h1>

          <div className="grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3">
            {linkedinPosts.map((post, i) => (
              <div
                key={post.url}
                style={{
                  animation: `fadeInUp 0.5s ease both`,
                  animationDelay: `${i * 60}ms`,
                }}
              >
                <LinkedInPostCard
                  post={post}
                  viewOriginalLabel={t('linkedin.viewOriginal')}
                  locale={locale}
                  viewInEnglishLabel={
                    locale === 'en' ? t('linkedin.viewInEnglish') : undefined
                  }
                  viewInSpanishLabel={
                    locale === 'en' ? t('linkedin.viewInSpanish') : undefined
                  }
                  className="w-full"
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
